import React from 'react';
import { string } from 'prop-types';

const DropdownArrowIcon = ({ color = 'font1-color', fontSize = '5px', className = '' }) => (
  <span
    style={{
      color: `var(--${color})`,
      fontSize: fontSize
    }}
    className={`icon-ic_arrow_dropdown ${className}`}
  />
);

DropdownArrowIcon.propTypes = {
  color: string,
  fontSize: string,
  className: string
};

export default DropdownArrowIcon;
